export default __webpack_public_path__ + "static/media/023-ticket office.b0771775.svg";